<script>
    import ShowGiftcard from '@/system/components/giftcards/ShowGiftcard';
    import StepCounter from '@/online_booking/new/components/common/StepCounter';
    import isEmpty from 'lodash/isEmpty';
    import Card from "@/online_booking/new/components/common/Card";
    import PreviousButton from '@/online_booking/new/components/common/PreviousButton';
    import GiftcardDesignSelection from '@/system/components/apps/giftcards/GiftcardDesignSelection.vue';
    import { mapGetters, mapActions, mapState } from 'vuex';
    import { http } from '@/system/http.js';
    import { objectToFormData } from '@/system/helpers';
    import { bookingKeys } from '@/online_booking/new/helpers/constants';

    export default {
        data() {
            return {
                isEmpty,
                visible: true,
                active: true,
                active_done: false,
                user: null,
                giftcardSettings: {},
                giftcard: {},
                loggedInClient: {},
                dataLoaded: false,
                permalink: null,
                preparingPayment: false,
                client_email: '',
            }
        },

        props: {
            id: {
                required: false,
                default: 'choose-giftcard',
            }
        },

        beforeUnmount() {
            this.$event_bus.$off('LoadData');
        },

        mounted() {
            this.$event_bus.$on('LoadData', (data) => {
                this.permalink = data.permalink;
                this.giftcardSettings = data.user.giftcards_settings;
                this.loggedInClient = data.logged_in_client;
                this.user = data.user;
                this.giftcard = {
                    user: data.user,
                    name: this.giftcardSettings.default_name,
                    description: this.giftcardSettings.default_description,
                    currency: this.currency,
                    amount: 0,
                    price_with_vat_formatted: parseInt(0).toFixed(2),
                    vat: this.giftcardSettings.online_purchase_vat,
                    vat_rate: this.giftcardSettings.online_purchase_vat_rate,
                    invoice: true,
                    draft: false,
                    expires_at: this.calculateExpiryDate(this.giftcardSettings),
                    client: this.loggedInClient ? this.loggedInClient.id : null,
                    status: 'not_used',
                    identifier: '__________',
                    design: this.giftcardSettings.giftcard_design,
                    text_color: this.giftcardSettings.giftcard_text_color ? this.giftcardSettings.giftcard_text_color : '#FFFFFF',
                    background_image_url: this.giftcardSettings.background_image_url,
                };

                this.$event_bus.$emit('GiftcardsShowed');
                this.dataLoaded = true;
                this.setCurrentStep('giftCard');
            });

            this.$event_bus.$on('clientUpdated', client => {
                this.loggedInClient = client;
            });
        },

        methods: {
            ...mapActions('OnlineBooking', ['setCurrentStep', 'setSelectedValue']),

            calculateExpiryDate(settings) {
                if (settings.online_purchase_interval_before_expiry !== '') {
                    return moment().add(
                        moment.duration(settings.online_purchase_interval_before_expiry)
                    ).format('YYYY-MM-DD');
                }

                return '';
            },

            updateBackgroundImage(file) {
                this.errors.clear();

                if (!file) {
                    this.giftcard.design = this.giftcardSettings.giftcard_design;
                    this.giftcard.background_image = null;
                    this.giftcard.background_image_url = this.giftcardSettings.background_image_url;
                } else {
                    let reader = new FileReader();
                    reader.onload = () => {
                        this.giftcard.background_image_url = reader.result;
                    };
                    reader.readAsDataURL(file);

                    this.giftcard.background_image = file;
                    this.giftcard.design = 0;
                }
            },

            titleClicked() {
                this.active_done = false;
                this.$event_bus.$emit('GiftcardsShowed');
            },

            continueToPayment() {
                this.preparingPayment = true;
                const formData = objectToFormData({
                    name: this.giftcard.name,
                    amount: this.giftcard.amount,
                    design: this.giftcard.design,
                    text_color: this.giftcard.text_color,
                });

                if (this.giftcard.background_image) {
                    formData.append('background_image', this.giftcard.background_image);
                }

                this.errors.clear();

                http.post(`/giftcards/${this.permalink}/choose-giftcard`, formData)
                    .then(({ data }) => {

                        if (data.success) {

                            this.preparingPayment = false;
                            this.active_done = true;
                            this.$event_bus.$emit('showGiftcardFillInformation', this.giftcard, data);
                        }


                    })
                    .catch(({ error, errorBag }) => {
                        this.preparingPayment = false;
                        this.$setErrorBag(errorBag);
                    })
            },
        },

        computed: {
            ...mapGetters('OnlineBooking', ['currentStepNumber', 'totalStepCount', 'getPreviousStepId']),
            ...mapState('OnlineBooking', ['currentStep']),

            currency() {
                return this.user ? Config.get(`countries.${this.user.country}.currency`) : '';
            },

            isGiftCardStepActive () {
                return this.currentStep === 'giftCard';
            },

            giftCardDetails () {
                return `${this.giftcard.name} - ${this.currency} ${this.giftcard.price_with_vat_formatted}`
            },

        },

        watch: {
            'giftcard.amount': function (newAmount) {
                newAmount = newAmount ? Math.max(0, parseFloat(newAmount)) : 0;
                this.giftcard.price_with_vat_formatted = parseFloat(newAmount).toFixed(2);
            },

            giftCardDetails (newValue) {
                this.setSelectedValue({
                    key: bookingKeys.GIFT_CARD,
                    value: newValue,
                });
            }
        },

        components: {
            PreviousButton,
            Card,
            ShowGiftcard,
            StepCounter,
            GiftcardDesignSelection,
        }
    }
</script>

<template id="choose-gift-card">
    <div class="gift-card-container" v-if="isGiftCardStepActive">
        <card class="p-0 rounded-lg" id="choose-gift-card-panel">
            <h4 class="section-title">
                <step-counter :current="currentStepNumber" :total="totalStepCount" />
                {{ trans('giftcards.purchasing.choose_giftcard_heading') }}
            </h4>

            <div
                id="chooseGiftcard"
                role="tabpanel"
                aria-labelledby="headingChooseGiftcard"
                data-parent="#booking-accordion"
            >
                <div class="panel-body">
                    <div class="row">
                        <div class="col-xs-12 col-sm-8 col-md-8">
                            <div class="form-group" :class="{ 'has-error': errors.has('name') }">
                                <label for="name">{{ trans('giftcards.name_label') }}</label>
                                <input type="text" class="form-control" name="name" v-model="giftcard.name">
                                <span v-if="errors.has('name')" class="help-block">{{ errors.first('name') }}</span>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-4 col-md-4">
                            <div class="form-group" :class="{ 'has-error' : errors.has('amount') }">
                                <label for="amount">{{ trans('giftcards.list_amount') }}</label>
                                <div class="input-group">
                                    <span class="input-group-addon">{{ currency }}</span>
                                    <input type="number" class="form-control" name="amount" v-model="giftcard.amount">
                                </div>
                                <span v-if="errors.has('amount')" class="help-block">{{ errors.first('amount') }}</span>
                            </div>
                        </div>

                        <div class="col-xs-12 m-t-10" v-if="dataLoaded">
                            <div v-if="giftcard" style="max-width: 700px; margin: auto;">
                                <show-giftcard :giftcard="giftcard" />
                            </div>

                            <div class="form-group" :class="{ 'has-error': errors.has('background_image') }">
                                <giftcard-design-selection
                                    :current-design="giftcard.design"
                                    @design-updated="giftcard.design = $event"
                                    @image-updated="updateBackgroundImage"
                                    :designs-per-row="6"
                                    @text-color-updated="giftcard.text_color = $event"
                                    :text-color="giftcard.text_color"
                                    class="mt-6"
                                />

                                <p class="help-block">{{ errors.first('background_image') }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex justify-between flex-wrap p-6 pt-0">
                <previous-button :previous-step-id="getPreviousStepId" />
                <button @click.prevent="continueToPayment" class="btn btn-custom" :disabled="preparingPayment">
                    <span>{{ trans('global.continue') }}</span>
                    <i class="zmdi zmdi-arrow-right ml-3"></i>
                </button>
            </div>
        </card>
    </div>
</template>
